/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetQuoteDataQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  quoteId: Types.Scalars['ID']['input'];
  calculationType: Types.QuotePdfCalculationType;
}>;


export type GetQuoteDataQuery = { quoteGetGeneratorData: { __typename: 'QuoteGetGeneratorDataResult', quoteData: any } };


export const GetQuoteDataDocument = gql`
    query GetQuoteData($projectId: ID!, $quoteId: ID!, $calculationType: QuotePdfCalculationType!) {
  quoteGetGeneratorData(
    projectId: $projectId
    quoteId: $quoteId
    calculationType: $calculationType
  ) {
    ... on QuoteGetGeneratorDataResult {
      quoteData
    }
  }
}
    `;

/**
 * __useGetQuoteDataQuery__
 *
 * To run a query within a React component, call `useGetQuoteDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteDataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      quoteId: // value for 'quoteId'
 *      calculationType: // value for 'calculationType'
 *   },
 * });
 */
export function useGetQuoteDataQuery(baseOptions: Apollo.QueryHookOptions<GetQuoteDataQuery, GetQuoteDataQueryVariables> & ({ variables: GetQuoteDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuoteDataQuery, GetQuoteDataQueryVariables>(GetQuoteDataDocument, options);
      }
export function useGetQuoteDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteDataQuery, GetQuoteDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuoteDataQuery, GetQuoteDataQueryVariables>(GetQuoteDataDocument, options);
        }
export function useGetQuoteDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuoteDataQuery, GetQuoteDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuoteDataQuery, GetQuoteDataQueryVariables>(GetQuoteDataDocument, options);
        }
export type GetQuoteDataQueryHookResult = ReturnType<typeof useGetQuoteDataQuery>;
export type GetQuoteDataLazyQueryHookResult = ReturnType<typeof useGetQuoteDataLazyQuery>;
export type GetQuoteDataSuspenseQueryHookResult = ReturnType<typeof useGetQuoteDataSuspenseQuery>;
export type GetQuoteDataQueryResult = Apollo.QueryResult<GetQuoteDataQuery, GetQuoteDataQueryVariables>;